import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction, setisjoin } from "../../actions/index";
// import { useHistory } from "react-router-dom";

import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";

function JoinauctionCode(match) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setJoinAuction);

  const [data, setData] = useState(
    getpageData ? getpageData.response.data.detail : {}
  );
  const [isActive, setActive] = useState(false);
  //   const getpageData = useSelector((state) => state.setactlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const [isDisabled, setDisabled] = useState(false);
  //   const refresh = useSelector((state) => state.setRefresh);
  //   const history = useHistory({ forceRefresh: true });
  const [cid, setCid] = useState(loginuser["cid"]);
  const history = useHistory({ forceRefresh: true });

  const onSubmit = (values) => {
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
        "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
      },
    };
    DataService.JoinauctionCode(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        dispatch(joinAuction({ response, values }));

        if (response.success == true) {
          toast.success("UPDATE PLAYER PROFILE", {
            theme: "dark",
            position: "bottom-center",
          });
          history.push(BASE_PATH + "join-auction");
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
    localStorage.removeItem('acode')
  };

  const fetchData = async () => {
    console.log("cid" + cid)
    console.log(loginuser["token"])
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.getJoinAuction({ cid: cid }, hdr)
      .then((res) => {
        let response = res.data;
       
        if (response.success == true) {
          let responsedata = response.data;
          setData(responsedata);
          dispatch(actlistData({ responsedata }));
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };

  const setauction = (ai, an) => {
    localStorage.setItem("auction_id", ai);
    localStorage.setItem("auction_name", an);
  };
  function tologin() {
    dispatch(setisjoin("true"));
    history.push('/')
  }
  useEffect(() => {
    
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
        "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
      },
    };
    DataService.JoinauctionCode2({ 'acode': localStorage.getItem('acode') }, hdr)

      .then((res) => {
        let response = res.data;
        console.log("response dikhaaa");
        console.log(response);
        // toast.dismiss(toastContainerId);

        dispatch(joinAuction({ response }));
        if (response.success == true) {
          console.log(response.data.act)
          setData(response.data.act)

          toast.success("Got Auction", {
            theme: "dark",
            position: "bottom-center",
          });
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        // setDisabled(false);
      })
      .catch(() => {
        console.log("Not valid");
        //   toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });

    window.scrollTo(0, 0);
  }, []);
function joinPlyercode(){
  console.log('triggered inside the joinplayer code func.')
}
  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        <div className="jinfo-main">
          <div className="col-md-6 join-auction-info jinfo">
            {data ? (
              <div className="row">
                <div className="col-md-2 join-auction-padding">
                  <Image
                    fallback={
                      <Shimmer width={50} height={50} />
                    }
                    src={
                      data && data.alogo != null
                        ?
                        auctiondefaultLogo
                        // getpageData.response.data.detail.path
                        // .getpageData.response.data.detail
                        // .alogo
                        : auctiondefaultLogo
                    }
                  ></Image>
                </div>

                <div className="col-md-10">
                  <h5>{data.auctionname} </h5>
                  <p>Auction on : {data.dt}</p>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <button className="btn btn-primary" onClick={tologin} style={{ 'marginTop': '3rem' }}>I want to Join</button>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default JoinauctionCode;
